import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import type { InterpolationValue } from 'styled-components';
import { graphql, useFragment } from 'react-relay';
import { Section } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { FilterItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/filter-item/index.tsx';
import type { systemFilters_navigationAppsSidebarFilters_SystemFiltersSection$key } from '@atlassian/jira-relay/src/__generated__/systemFilters_navigationAppsSidebarFilters_SystemFiltersSection.graphql';
import { messages } from './messages.tsx';

type Props = {
	baseHref: string;
	jiraQuery: systemFilters_navigationAppsSidebarFilters_SystemFiltersSection$key;
	sectionCustomCss?: InterpolationValue[];
};

export const SystemFiltersSection = ({ baseHref, jiraQuery, sectionCustomCss }: Props) => {
	const { formatMessage } = useIntl();

	const data = useFragment(
		graphql`
			fragment systemFilters_navigationAppsSidebarFilters_SystemFiltersSection on JiraQuery
			@argumentDefinitions(cloudId: { type: "ID!" }) {
				systemFilters(cloudId: $cloudId, isFavourite: false) {
					edges {
						node {
							filterId
							...filterItem_navigationAppsSidebarCommon
						}
					}
				}
			}
		`,
		jiraQuery,
	);

	const systemFilterEdges = data.systemFilters?.edges || [];
	if (!systemFilterEdges.length) {
		return null;
	}

	return (
		<Section
			// TODO remove css prop once @atlaskit/section design gets updated
			// @ts-expect-error - TS2322: Index signature for type 'string' is missing in type 'StyledComponentClass<any, any, any>'.
			// eslint-disable-next-line @compiled/no-css-prop-without-css-function
			css={sectionCustomCss}
			title={formatMessage(messages.newDefaultFiltersHeader)}
		>
			{systemFilterEdges.map((edge) =>
				edge?.node ? (
					<FilterItem key={edge.node.filterId} baseHref={baseHref} filter={edge.node} />
				) : null,
			)}
		</Section>
	);
};
